/* eslint-disable no-sequences */
/* eslint-disable no-return-assign */
import React, { useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';

import { useIntl } from 'react-intl';
import Link from '../../UI/Link/Link';
import Image from '../../UI/Image/Image';

import {
  Phase3Screen,
  SectionWrapper,
  BladeTitle,
  BladeSubtitle,
  DetailSummary,
  ImgWrapper,
  List,
  ListItemWrapper,
  ListImage,
  ListItem,
  CoAddress,
  CoName,
  CoSite,
  DoneButton,
} from './styles';

interface Props {
  reserveData: Record<string, any>;
  confCode?: number;
  closeBlade: (...args: any[]) => any;
  selectedLocation: Record<string, any>;
  chosenPhoneDetails: string;
  phoneModel: string;
  selectedStorageSize: string;
  selectedColour: string;
  carrierName?: string;
}

const ReservePhase3 = ({
  reserveData,
  confCode,
  closeBlade,
  chosenPhoneDetails,
  phoneModel,
  selectedStorageSize,
  selectedColour,
  carrierName,
  selectedLocation,
}: Props) => {
  const { locale } = useIntl();
  // Reserve labels data
  const reserveLabelSection = reserveData.combinatorSectionItems.find(
    (item) => item.contentful_id === '33NuOzdAzgXO1jPEs0x7sS',
  );
  const reserveLabels = reserveLabelSection.formFields.reduce(
    (obj, item) => ((obj[item.contentful_id] = item), obj),
    {},
  );
  const imageSection = reserveData.combinatorSectionItems.find((item) => item.contentful_id === '5wsZEr1HrQMeecc43RGIex');

  // CREATE DATALAYER FOR GTM ANALYTICS
  useEffect(() => {
    // Create dataLayer object for GTM if it doesn't exist yet
    window.dataLayer = window.dataLayer || [];
    // Structure data to submit
    const phase3Data = {
      event: 'reservenow',
      reservePhase: 'phase 3 - success screen',
      phoneSummary: chosenPhoneDetails,
      phoneModel,
      phoneColour: selectedColour,
      phoneStorage: selectedStorageSize,
      carrier: carrierName,
      storeSummary: `${selectedLocation.commonInfo.address.line1}, ${selectedLocation.commonInfo.address.city},
        ${selectedLocation.commonInfo.address.province}, ${selectedLocation.commonInfo.address.postalCode}`,
    };
    window.dataLayer.push(phase3Data);

    /* eslint-disable */
    //check if hj function exists
    (window as any).hj =
      (window as any).hj ||
      function () {
        (hj.q = hj.q || []).push(arguments);
      };
    //hj('trigger', 'phone_reservation');
    /* eslint-enable */
  }, [
    carrierName,
    chosenPhoneDetails,
    phoneModel,
    selectedColour,
    selectedLocation.commonInfo.address.city,
    selectedLocation.commonInfo.address.line1,
    selectedLocation.commonInfo.address.postalCode,
    selectedLocation.commonInfo.address.province,
    selectedStorageSize,
  ]);

  return (
    <Phase3Screen>
      <BladeTitle data-testid="blade-title">
        {ReactHtmlParser(reserveLabels['2pfvOp4JsqVbm5Wh5ya7Y7'].displayLabel)}
      </BladeTitle>
      {/* AIRPLANE IMG */}
      <SectionWrapper>
        <ImgWrapper>
          <Image image={imageSection.foregroundImageDesktop} />
        </ImgWrapper>
        {/* CONF CODE */}
        <BladeSubtitle>
          {ReactHtmlParser(
            reserveLabels['3dA6z7T98Wfq938oolztpf'].displayLabel,
          )}
        </BladeSubtitle>
        <DetailSummary>{confCode}</DetailSummary>
      </SectionWrapper>

      {/* LIST OF NEXT STEPS  */}
      <SectionWrapper>
        <BladeSubtitle id="listTitle">
          {ReactHtmlParser(
            reserveLabels['4lLyhtwlMP7Lqmmj3gKOnX'].displayLabel,
          )}
        </BladeSubtitle>

        <List>
          <ListItemWrapper key={1}>
            <ListImage>{1}</ListImage>
            <ListItem>
              {ReactHtmlParser(
                reserveLabels['59of2wc2paoEYqGyhHcoJn'].displayLabel,
              )}
            </ListItem>
          </ListItemWrapper>
          <ListItemWrapper key={2}>
            <ListImage>{2}</ListImage>
            <ListItem>
              {ReactHtmlParser(
                reserveLabels['14D7Eb7QJmperiyIbsbKYP'].displayLabel,
              )}
            </ListItem>
          </ListItemWrapper>
          <ListItemWrapper key={3}>
            <ListImage>{3}</ListImage>
            <ListItem>
              {ReactHtmlParser(
                reserveLabels['53JzrPmYtUo2xKbgAa7fVG'].displayLabel,
              )}
            </ListItem>
          </ListItemWrapper>
        </List>
      </SectionWrapper>

      {/* CLOSE BLADE */}
      <SectionWrapper id="doneButton">
        <DoneButton type="button" onClick={closeBlade}>
          {ReactHtmlParser(reserveLabels.gYhWuxJMh3N61L2zWGB6O.displayLabel)}
        </DoneButton>
      </SectionWrapper>
      <hr />

      {/* CORPORATE ADDRESS */}
      <SectionWrapper id="coInfo">
        <CoName>Loblaws Inc.,</CoName>
        <CoAddress>
          {ReactHtmlParser(
            reserveLabels['4mU365hFKVsOgILdegU9XI'].displayLabel,
          )}
        </CoAddress>
        <CoSite>
          <Link to={`/${locale}`}>
            {ReactHtmlParser(reserveLabels.qIgCceh6oUnpCPzJ47eY1.displayLabel)}
          </Link>
        </CoSite>
      </SectionWrapper>
    </Phase3Screen>
  );
};

export default ReservePhase3;
